import { hasShiftTimes } from './egScheduleDisplay';

// Display-only tokens. Saved category, times and schedule calculations remain authoritative.
export const EG_SHIFT_COLORS = Object.freeze({
  opening: '#27923D', mid_shift: '#E5BA00', closing: '#0787D1',
  training: '#8052C8', cross_center: '#F47B16', unavailable: '#E13D3D', unassigned: '#8A9399',
});
export const EG_SHIFT_LABELS = Object.freeze({
  opening: 'Opening', mid_shift: 'Mid-shift', closing: 'Closing',
  training: 'Training', cross_center: 'Cross-center', unavailable: 'Off', unassigned: 'Unassigned',
});

function compactTime(value) {
  const [hour, minute] = value.split(':').map(Number);
  return `${(hour + 11) % 12 + 1}:${String(minute).padStart(2, '0')}${hour >= 12 ? 'p' : 'a'}`;
}

export function getShiftPresentation(shift) {
  const hasTimes = hasShiftTimes(shift);
  const requested = shift?.requested === true || shift?.shift_type === 'requested';
  const known = Object.prototype.hasOwnProperty.call(EG_SHIFT_COLORS, shift?.shift_type);
  const type = known ? shift.shift_type : shift?.shift_type === 'requested' && !hasTimes ? 'unavailable' : 'unassigned';
  const label = !shift ? 'Unassigned' : shift.shift_type === 'requested'
    ? (hasTimes ? 'Requested' : 'Requested off') : known ? EG_SHIFT_LABELS[type] : 'Shift';
  return { type, label, color: shift?.mod === true ? "#111111" : EG_SHIFT_COLORS[type], requested, hasTimes,
    timeLabel: hasTimes ? `${compactTime(shift.start)}–${compactTime(shift.end)}` : '' };
}
